<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Operative Registers"></crud-nav-header>


            <crud-nav-scroll>
                <ul>
                    <li v-for="item in items">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(item)">{{ item.date }}
                                <small v-if="item.operatives.length">({{ item.operatives.length }} Operatives)</small>
                            </a>
                        </div>
                    </li>
                </ul>
            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Register" can-go-back-to-nav="true"></crud-main-header>
                <crud-errors :errors="errors"></crud-errors>
                <dl>
                    <dt>Register Date</dt>
                    <dd>
                        <flat-pickr v-model="new_item.date"
                                    placeholder="What date is this register for..."></flat-pickr>
                        <div v-if="registerExistsForDate(new_item.date)"><strong>Note: </strong>A register already
                            exists for this date. Any operatives you add will be merged with the operatives on the
                            existing register.
                        </div>
                    </dd>
                    <template v-if="new_item.suggestedOperatives.length">
                        <dt>Booked Operatives</dt>
                        <dd>
                            <ul class="booked-operatives-list">
                                <li v-for="sugOp in new_item.suggestedOperatives">
                                    <span>{{ sugOp.name }}</span> <a href="#"
                                                                     @click.prevent="addToAbsentees(new_item, sugOp)"><i
                                    class="fa fa-times"></i></a> <a href="#"
                                                                    @click.prevent="addToOperatives(new_item,sugOp)"><i
                                    class="fa fa-check"></i></a>
                                </li>
                            </ul>
                        </dd>
                    </template>
                    <dt>Operatives Present</dt>
                    <dd>
                        <v-select v-model="new_item.operatives_dropdown"
                                  multiple
                                  placeholder="Choose the operatives present on this date..."
                                  :options="people"></v-select>
                    </dd>
                    <dt>Operatives Absent</dt>
                    <dd>
                        <v-select v-model="new_item.absentees_dropdown"
                                  multiple
                                  placeholder="Choose the operatives absent on this date..."
                                  :options="people"></v-select>

                    </dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss hidden-desktop" @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="addItem()">
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i> Create Register
                    </a>
                </div>


            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Edit Register For Date '+current_item.date" can-delete="true" can-edit="true"
                                  can-go-back="true" :item="current_item"></crud-main-header>


                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Register Date</dt>
                    <dd><input type="date" disabled v-model="current_item.date"
                               placeholder="What date is this register for..."/></dd>
                    <dt>Operatives Present</dt>
                    <dd>
                        <v-select v-model="current_item.operatives_dropdown"
                                  multiple
                                  placeholder="Choose the operatives present on this date..."
                                  :options="people"></v-select>

                    </dd>
                    <dt>Operatives Absent</dt>
                    <dd>
                        <v-select v-model="current_item.absentees_dropdown"
                                  multiple
                                  placeholder="Choose the operatives absent on this date..."
                                  :options="people"></v-select>

                    </dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Register
                    </a>
                </div>

            </crud-edit>
            <crud-view>
                <div v-if="adding_note">
                    <crud-main-header :title="'Adding Note For '+adding_note_operative.name" can-go-back="true"
                                      :item="current_item"></crud-main-header>

                    <crud-errors :errors="errors"></crud-errors>

                    <dl>
                        <dt>Add Note For {{ adding_note_operative.name }}</dt>
                        <dd>
                            <textarea v-model="adding_note_content"
                                      placeholder="Add a new note for operative."></textarea>
                        </dd>
                    </dl>

                    <div class="action-button-group">
                        <a href="#" class="action-button action-button-success" @click.prevent="addNote()">
                            <i class="fa fa-plus-square-o" aria-hidden="true"></i> Add Note
                        </a>
                    </div>

                </div>
                <div v-else>
                    <crud-main-header :title="'Register For '+current_item.date" can-delete="true" can-edit="true"
                                      can-go-back-to-nav="true" :item="current_item"></crud-main-header>

                    <dl>
                        <dt>Operatives Present</dt>
                        <dd>
                            <ul class="operative-list" v-if="current_item.has_operatives">
                                <li v-for="operative in current_item.operatives">
                                    {{ operative.name }}
                                    <div v-if="operative.notes">
                                        {{ operative.notes }} <a class="add-note-button" href="#"
                                                                 @click.prevent="showAddNote(operative)"><i
                                        class="fa fa-pencil" aria-hidden="true"></i> Edit</a>
                                    </div>
                                    <a class="add-note-button" href="#" @click.prevent="showAddNote(operative)"
                                       v-else><i
                                        class="fa fa-plus-square-o" aria-hidden="true"></i> Note</a>
                                </li>
                            </ul>
                            <span v-else>None</span>
                        </dd>
                        <dt>Operatives Absent</dt>
                        <dd>
                            <ul class="operative-list" v-if="current_item.has_absentees">
                                <li v-for="operative in current_item.absentees">
                                    {{ operative.name }}
                                    <div v-if="operative.notes">
                                        {{ operative.notes }} <a class="add-note-button" href="#"
                                                                 @click.prevent="showAddNote(operative)"><i
                                        class="fa fa-pencil" aria-hidden="true"></i> Edit</a>
                                    </div>
                                    <a class="add-note-button" href="#" @click.prevent="showAddNote(operative)"
                                       v-else><i
                                        class="fa fa-plus-square-o" aria-hidden="true"></i> Note</a>
                                </li>
                            </ul>
                            <span v-else>None</span>
                        </dd>
                        <dt v-if="current_item.created_by">Created By</dt>
                        <dd v-if="current_item.created_by">{{ current_item.created_by.name }}</dd>
                        <dt v-if="current_item.last_updated_by">Updated By</dt>
                        <dd v-if="current_item.last_updated_by">{{ current_item.last_updated_by.name }}</dd>
                    </dl>

                </div>


            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';

var newItemFormat = {
    operatives: [],
    absentees: [],
    operatives_dropdown: [],
    absentees_dropdown: [],
    date: '',
    suggestedOperatives: [],
    allBookedOperatives: []
};

export default {
    components: {
        vSelect, flatPickr
    },
    props: ['package_id'],
    data() {
        return {
            name: 'operatives-register',
            items: [],
            current_item: {},
            new_item: $.extend({}, newItemFormat),
            people: [],
            adding_note: false,
            adding_note_operative: false,
            adding_note_content: '',
            errors: null
        }
    },
    watch: {
        "new_item.operatives": function () {
            this.calculateSuggestedOperatives();
        },
        "new_item.absentees": function () {
            this.calculateSuggestedOperatives();
        },
        "new_item.date": function () {
            var that = this;
            this.getBookingsForDate(this.new_item.date, function (data) {
                that.new_item.allBookedOperatives = data;
                that.calculateSuggestedOperatives();
            });
        }
    },
    computed: {},
    methods: {
        calculateSuggestedOperatives: function () {
            var that = this;
            this.new_item.suggestedOperatives = [];
            _.forEach(this.new_item.allBookedOperatives, function (bookedOperative) {
                var exclude = false;
                _.filter(that.new_item.operatives, function (operative) {
                    if (operative.id === bookedOperative.id) {
                        exclude = true;
                    }
                });
                _.filter(that.new_item.absentees, function (operative) {
                    if (operative.id === bookedOperative.id) {
                        exclude = true;
                    }
                });
                if (!exclude) {
                    that.new_item.suggestedOperatives.push(bookedOperative);
                }
            });
        },
        showAddNote: function (operative) {
            this.adding_note = true;
            if (operative.notes) {
                this.adding_note_content = operative.notes;
            } else {
                this.adding_note_content = '';
            }
            this.adding_note_operative = operative;
        },
        addToAbsentees: function (item, sugOp) {
            this.new_item.absentees_dropdown.push({
                label: sugOp.name,
                value: sugOp.id,
            });
            this.new_item.absentees.push({
                name: sugOp.name,
                id: sugOp.id,
            });

            this.new_item.absentees = _.uniqBy(this.new_item.absentees, function (operative) {
                return operative.id;
            });
            this.new_item.absentees_dropdown = _.uniqBy(this.new_item.absentees_dropdown, function (operative) {
                return operative.value;
            });
        },
        addToOperatives: function (item, sugOp) {
            this.new_item.operatives_dropdown.push({
                label: sugOp.name,
                value: sugOp.id,
            });
            this.new_item.operatives.push({
                name: sugOp.name,
                id: sugOp.id,
            });

            this.new_item.operatives = _.uniqBy(this.new_item.operatives, function (operative) {
                return operative.id;
            });
            this.new_item.operatives_dropdown = _.uniqBy(this.new_item.operatives_dropdown, function (operative) {
                return operative.value;
            });
        },
        addNote: function () {
            var addNoteUrl = appUrls.register.add_note.replace('REPLACEME', this.current_item.id).replace('OPERATIVEREPLACEMENT', this.adding_note_operative.id);
            var that = this;

            axios.put(addNoteUrl, {
                note: this.adding_note_content
            })
                .then(response => {

                    that.stopNoteAdding();
                    that.viewItem(response.data.data);
                    that.getItems();
                }).catch(function (error) {
                if (_.isObject(error) && error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },
        registerExistsForDate(date) {
            var exists = false;

            _.forEach(this.items, function (register) {
                if (register.date == date) {
                    exists = true;
                }
            });

            return exists;
        },
        stopNoteAdding: function () {
            this.adding_note_operative = false;
            this.adding_note = false;
            this.adding_note_content = '';
        },
        getBookingsForDate(date, callback) {
            axios.get(appUrls.packages.bookings.index.replace('REPLACEME', this.package_id), {
                params: {
                    "package": this.package_id,
                    "date": date
                }
            })
                .then(response => {
                    callback(response.data.data);
                });
        },
        saveItem: function () {
            var that = this;
            var editingItem = $.extend({}, this.current_item);
            var formDataObject = new FormData();
            var saveUrl = appUrls.register.update.replace('REPLACEME', editingItem.id); // @todo Change This

            delete editingItem["operatives"];
            delete editingItem["absentees"];

            _.forEach(editingItem.operatives_dropdown, function (operative) {
                formDataObject.append('operatives[]', operative.value);
            });

            delete editingItem["operatives_dropdown"];

            _.forEach(editingItem.absentees_dropdown, function (absentees) {
                formDataObject.append('absentees[]', absentees.value);
            });

            delete editingItem["absentees_dropdown"];


            _.forIn(editingItem, function (value, key) {
                formDataObject.append(key, value);
            });

            formDataObject.append('_method', 'put');

            axios.request({
                method: 'post',
                url: saveUrl,
                data: formDataObject,
                config: {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            }).then(response => {
                that.viewItem(response.data.data);

            }).catch(function (error) {
                if (error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },

        deleteItem(itemToDelete) {
            var that = this;
            var title = 'Are you sure you want to delete this operative register entry?';
            var description = 'Deleting this entry is irreversible. Are you sure you want to delete it?';

            var standardCallback = function (itemToDelete) {
                let index = that.items.indexOf(itemToDelete);
                that.items.splice(index, 1);

                eventBus.$emit('crud-show-new-' + that.name);
                eventBus.$emit('crud-back-to-nav-' + that.name);
                that.getItems();
            };

            eventBus.$emit('delete-modal-open', title, description, function () {
                axios.delete(appUrls.register.destroy.replace('REPLACEME', itemToDelete.id));
                standardCallback(itemToDelete);
            });
        },
        resetErrors() {
            this.errors = null;
        },
        addItem() {
            var that = this;
            var data = $.extend({}, this.new_item);
            var formDataObject = new FormData();
            var addUrl = appUrls.register.store;
            var operatives = $.extend({}, data.operatives_dropdown);
            var absentees = $.extend({}, data.absentees_dropdown);
            delete data["operatives"];
            delete data["operatives_dropdown"];
            delete data["absentees"];
            delete data["absentees_dropdown"];

            _.forEach(operatives, function (operative) {
                formDataObject.append('operatives[]', operative.value);
            });

            _.forEach(absentees, function (absentee) {
                formDataObject.append('absentees[]', absentee.value);
            });

            data.package = this.package_id;

            _.forIn(data, function (value, key) {
                formDataObject.append(key, value);
            });


            var standardCallback = function (item) {
                that.items.push(item);
                that.viewItem(item);

                that.getItems();
            };

            axios.request({
                method: 'post',
                url: addUrl,
                data: formDataObject,
                config: {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            }).then(response => {
                standardCallback(response.data.data);

                // Any other custom methods here.
            }).catch(function (error) {
                if (error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },
        getPeople() {
            var that = this;
            axios.get(appUrls.contacts.index)
                .then(response => {
                    _.forEach(response.data.data, function (person) {
                        that.people.push({
                            label: person.name,
                            value: person.id
                        });
                    });
                });
        },
        getItems() {
            var that = this;
            var url = appUrls.register.index;
            var getVarName = 'register';
            var params = {
                "package": this.package_id
            };

            axios.get(url, {params: params})
                .then(response => {
                    that.items = response.data.data;

                    var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;
                    if (hasGetVariable) {
                        var idFromVariable = getParameterByName(getVarName);
                        if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                            that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                        }
                    }
                });
        },
        viewItem(item) {
            window.eventBus.$emit('crud-view-item-' + this.name, item);
        },
        backToNav: function () {
            window.eventBus.$emit('crud-back-to-nav-' + this.name);
        },
        backToItem: function () {
            window.eventBus.$emit('crud-back-' + this.name);
        }
    },
    mounted() {
        var that = this;

        this.getItems();
        this.getPeople();

        window.eventBus.$on('crud-errors-dismissed', function () {
            that.errors = null;
        });
        window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
            that.search_query = query;
            that.getItems();
        }, 250));

        window.eventBus.$on('crud-search-hidden-' + this.name, function (query) {
            that.search_query = null;
            that.getItems();
        });

        window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
            that.new_item = $.extend({}, newItemFormat);
            this.current_item = item;
            that.resetErrors();
        });

        window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
            that.deleteItem(item);
            that.resetErrors();
        });

        window.eventBus.$on('crud-view-item-' + this.name, function (item) {
            that.new_item = $.extend({}, newItemFormat);
            that.current_item = item;
            that.adding_note = false;
            that.adding_note_operative = false;
            that.adding_note_content = '';
            that.resetErrors();
        });

        window.eventBus.$on('crud-back-' + this.name, function (item) {
            that.current_item = item;
            that.viewItem(item);
            that.resetErrors();
        });

        window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
            that.current_item = {};
            that.new_item = $.extend({}, newItemFormat);
            that.resetErrors();
        });
    }
}
</script>

<style lang="scss">
/*SASS Goes Here*/
@import '../../sass/setup';

.operative-list {
    margin-left: 1.5em;

    li {
        list-style: disc;

        div {
            display: block;
            font-style: italic;
            font-size: 15px;
            color: #999;
            margin: -0.5em 0 0 0;
        }
    }
}

.add-note-button {
    font-weight: 400;
    text-decoration: none;
    margin-left: 12px;
    font-size: 15px;
    opacity: 0.5;
    transition: all 0.1s ease-in-out;

    &:hover {
        text-decoration: none;
        opacity: 1;
    }
}

.booked-operatives-list {
    li {
        margin-bottom: 1.2em;

        span {
            background-color: #ecf0f1;
            border-radius: $standardBorderRadius;
            padding: 0.5em;
            min-width: 150px;
            display: inline-block;
        }

        a {
            background-color: $red;
            border-radius: $standardBorderRadius;
            padding: 0.5em;
            color: #FFF;

            &:hover {
                background-color: lighten($red, 10);
            }

            &:last-of-type {
                background-color: $green;

                &:hover {
                    background-color: lighten($green, 10);
                }
            }
        }
    }
}

</style>
